import { httpClient } from "./httpClient";

type Environment = {
  id: number;
  name: string;
  isActive: boolean;
};

type Data = {
  environments: Environment[];
};

export async function getEnvironments(
  application?: number
): Promise<Environment[]> {
  try {
    const { data } = await httpClient.get<Data>(
      `/api/v1/environments${application ? `/search?appId=${application}` : ``}`
    );

    return data.environments;
  } catch (error) {
    throw error;
  }
}
